import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IGigComplianceRow } from '@/components/agent/gig-compliance/types';

import {
  CardContainer,
  HeaderLabel,
  Row,
  RowCell,
  RowsContainer,
} from '@/components/agent/gig-compliance/ComplianceTable.styles';
import { COMPLIANCE_CONFIG_TABLE } from '@/constants/contracts';
import { LoaderWrapper, NoShowsCardSkeleton } from '@/components/common';

interface IProps {
  rowsToDisplay: IGigComplianceRow[];
  isLoading: boolean;
}

const NoShowsCard = ({ rowsToDisplay, isLoading }: IProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <CardContainer width={COMPLIANCE_CONFIG_TABLE.nowShows.width}>
      <LoaderWrapper className="h-100" isLoading={isLoading} loader={<NoShowsCardSkeleton />}>
        <HeaderLabel>{t`gigCompliance.complianceTable.labelNoShows`}</HeaderLabel>
        <RowsContainer
          colorOne={COMPLIANCE_CONFIG_TABLE.nowShows.colorOne}
          colorTwo={COMPLIANCE_CONFIG_TABLE.nowShows.colorTwo}
          colorText={COMPLIANCE_CONFIG_TABLE.nowShows.colorText}
        >
          {rowsToDisplay.map(row => (
            <Row key={row.weekSpan}>
              <RowCell className={row.noShows?.isWarning && row.isPublished ? 'warning' : ''}>
                {row.noShows?.value && Number(row.noShows?.value) > 0 && row.isPublished ? row.noShows.value : ''}
              </RowCell>
            </Row>
          ))}
        </RowsContainer>
      </LoaderWrapper>
    </CardContainer>
  );
};

export { NoShowsCard };
